import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';
import type { Column } from '@tanstack/react-table';

export const useGetColumnName = () => {
  const { table } = useTiclickTableContext();
  const { columnNames } = table.options.meta?.state || {};

  const getColumnName = <T, TValue>(column: Column<T, TValue>) => {
    const original = column.columnDef?.header as string;
    const newName = columnNames?.[column.id];
    const displayed = newName || original;
    return { original, newName, displayed };
  };

  return getColumnName;
};
